import React from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { ChildVenue } from "../../types/dataTypes";

interface VenueFormGroupProps {
  venues: ChildVenue[];
  selectedVenues: string[];
  onVenueToggle: (clickedVenue: string) => void;
  toggleSelectAllVenues: (selectAll: boolean) => void;
  selectAllVenuesLabel: string;
  venueDistanceLabel?: string;
}

export const VenueFormGroup: React.FC<VenueFormGroupProps> = ({
  venues,
  selectedVenues,
  onVenueToggle,
  toggleSelectAllVenues,
  selectAllVenuesLabel,
  venueDistanceLabel = "away",
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const areAllVenuesSelected =
    venues.length > 0 && venues.length === selectedVenues.length;

  return (
    <FormGroup>
      <FormControlLabel
        key={"select-all"}
        onChange={() => toggleSelectAllVenues(!areAllVenuesSelected)}
        sx={{ mb: { xs: 3, md: 1 }, mr: 0 }}
        label={
          <>
            <Typography
              color={"primary"}
              sx={{
                width: "100%",
                fontSize: { xs: "medium", md: "medium" },
              }}
            >
              {selectAllVenuesLabel}
            </Typography>
          </>
        }
        control={<Checkbox checked={areAllVenuesSelected} size="large" />}
      />
      {venues.map(({ venue_name, distanceBetweenUserAndVenue, venue_slug }) => {
        const isSelected = selectedVenues.includes(venue_slug);
        const textColour = isSelected ? "text.primary" : "text.secondary";
        const distanceText = `${distanceBetweenUserAndVenue.toFixed(
          1,
        )} km ${venueDistanceLabel}`;

        return (
          <FormControlLabel
            key={venue_slug}
            onChange={() => onVenueToggle(venue_slug)}
            sx={{ mb: { xs: 3, md: 1 }, mr: 0 }}
            label={
              isMobile ? (
                <>
                  <Typography
                    color={textColour}
                    sx={{
                      width: "100%",
                      fontSize: "medium",
                    }}
                  >
                    {venue_name}
                  </Typography>
                  <Typography
                    color={textColour}
                    sx={{
                      width: "100%",
                      fontSize: { xs: "small", md: "medium" },
                    }}
                  >
                    {distanceText}
                  </Typography>
                </>
              ) : (
                <Typography
                  color={textColour}
                  sx={{ width: "100%", fontSize: { xs: "small", md: "large" } }}
                >
                  {venue_name} | {distanceText}
                </Typography>
              )
            }
            control={
              <Checkbox
                checked={selectedVenues.includes(venue_slug)}
                size="large"
              />
            }
          />
        );
      })}
    </FormGroup>
  );
};
